module.exports = __webpack_public_path__ + "img/G.01fab659.png";